import { AgTechButtonProps, AgTechButton, AgTechActionButton } from '@agtech/web/components/Buttons/AgTechButtons';
import { SaleInvoiceModifier } from '@sales/data/sales/InvoiceModifiers/SaleInvoiceModifierData';
import { useSaleInvoiceModifierDataDeleteInvoiceModifierAction } from '@sales/data/sales/InvoiceModifiers/SaleInvoiceModifierDataActions';
import React from 'react'
import SaleInvoiceModifierActionMenu from '../menus/SaleInvoiceModifierActionMenu';

export type SaleInvoiceModifierRemovalButtonProps = AgTechButtonProps & {
    InvoiceModifier: SaleInvoiceModifier
}

export const SaleInvoiceModifierRemovalButton = (props: SaleInvoiceModifierRemovalButtonProps) => {
    let deleteInvoiceModifierAction = useSaleInvoiceModifierDataDeleteInvoiceModifierAction();

    let buttonProps: AgTechButtonProps = {
        ...props,
        action: e => e.actions.executeDataActionInModal(deleteInvoiceModifierAction, {
            submittedEntity: props.InvoiceModifier
        })
    };

    buttonProps.text = buttonProps.text ? buttonProps.text : 'Delete';
    buttonProps.icon = buttonProps.icon ? buttonProps.icon : 'fas fa-times';

    return <AgTechButton {...buttonProps} />
}

export type SaleInvoiceModifierActionButtonProps = {
    InvoiceModifier: SaleInvoiceModifier
}

export const SaleInvoiceModifierActionButton = (props: SaleInvoiceModifierActionButtonProps) => {
    return (
        <AgTechActionButton>
            <SaleInvoiceModifierActionMenu InvoiceModifier={props.InvoiceModifier} />
        </AgTechActionButton>
    )
}